export enum ErrorCode {
	UNKNOWN = 'errors.com.epicgames.unknown_error',
	SERVER_ERROR = 'errors.com.epicgames.server_error',
	BAD_REQUEST = 'errors.com.epicgames.bad_request',
	UNAUTHORIZED = 'errors.com.epicgames.unauthorized',
	FORBIDDEN = 'errors.com.epicgames.forbidden',
	NOT_FOUND = 'errors.com.epicgames.not_found',
	CONFLICT = 'errors.com.epicgames.conflict',
	UNSUPPORTED_MEDIA_TYPE = 'errors.com.epicgames.unsupported_media_type',
	SERVICE_UNAVAILABLE = 'errors.com.epicgames.service_unavailable',
	VALIDATION_FAILED = 'errors.com.epicgames.validation.validation_failed',
	CONTACT_SUPPORT = 'epic.ecp.shared.common.contactSupport',
	THROTTLED = 'errors.com.epicgames.throttled',
	RESUBMIT = 'errors.com.epicgames.resubmission',
	OFFLINE = 'errors.com.epicgames.offline_network',
	TIMEOUT = 'errors.com.epicgames.timeout',

	//partner service errors
	PARTNER_FRAUD_TOP_UP_LIMIT = 'errors.com.epicgames.posa.redemption.fraud.account_balance_top_up_limit',
	PARTNER_FRAUD_REDEEM_FORBIDDEN = 'errors.com.epicgames.posa.redemption.fraud.redemption_forbidden'
}

export const ErrorCodeValues = new Set<string>(Object.values(ErrorCode));

export interface ServiceError {
	errorCode: string;
	errorMessage: string;
	messageVars: Array<string>;
	numericErrorCode: number;
	originatingService: string;
	intent: string;
}

export interface ErrorResponse<ErrorData = Record<string, string>> {
	error: string;
	data?: ErrorData;
}

export type SerializedError = {
	name?: string;
	message?: string;
	stack?: string;

	// Common Node/undici fields (optional)
	code?: string;
	errno?: number | string;
	syscall?: string;
	address?: string;
	port?: number;

	// Nested error cause (Node 16+ / undici uses this a lot)
	cause?: SerializedError;

	// If it wasn't an Error
	value?: unknown;
};

export type NodeLikeError = Error & {
	code?: string;
	errno?: number | string;
	syscall?: string;
	address?: string;
	port?: number;
	cause?: unknown;
};

export type CspViolationPayload = {
	violatedDirective: string;
	blockedURI: string;
	documentURI: string;
	effectiveDirective?: string;
	disposition?: string;
	statusCode?: number;
	sourceFile?: string;
	lineNumber?: number;
	columnNumber?: number;
};

export type ScriptLoadErrorPayload = {
	scriptURL: string;
	documentURI: string;
	async?: boolean;
	defer?: boolean;
};
